import React from 'react';
import PropTypes from 'prop-types';

/**
 * SwimRun Badge
 * @param {Object} props
 * @param {string} props.title - The title of the badge
 * @returns {JSX.Element}
 */
export default function SwimRunBadge({ title = 'SwimRun — Dubbel Rondje' }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-label={title} role="img">
      <rect width="20" height="20" rx="10" fill="#b4c002" />
      {/* Paddles */ }
      <path d="M5.5 6l1 2-1 2" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M14.5 6l-1 2 1 2" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
      {/* Pullbuoy */ }
      <path d="M8.5 8c0-1 .5-2 1.5-2s1.5 1 1.5 2-.5 2-1.5 2-1.5-1-1.5-2z" fill="white" />
      <path d="M8.5 12c0-1 .5-2 1.5-2s1.5 1 1.5 2-.5 2-1.5 2-1.5-1-1.5-2z" fill="white" />
    </svg>
  );
}

SwimRunBadge.propTypes = {
  title: PropTypes.string,
};
